<template>
    <div class="flex items-center gap-1">
        <em :class="operabilityColor" class="bg- block h-3 w-3 rounded-full" />
        <div :class="{ 'line-through': strikeThrough }">{{ label || '-' }}</div>
    </div>
</template>
<script setup>
import { computed } from 'vue';

const props = defineProps({
    operability: Object,
    usageCategory: Object,
    strikeThrough: Boolean,
});

const operabilityColor = computed(() => {
    return props.operability?.value === 'operable' ? 'bg-success' : 'bg-red';
});

const label = computed(() => {
    return [props.operability?.label, props.usageCategory?.label].filter(Boolean).join('/');
});
</script>
